export default "__VITE_ASSET__652a7fd6__"